import { Typography as MuiTypography, TypographyProps } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { WithStyles, withStyles } from '@mui/styles';
import { DistributiveOmit } from '@mui/types';
import classNames from 'classnames';
import React from 'react';

const styles = (_) => ({
  montserrat: {
    fontFamily: '"Montserrat", "Arial", "Helvetica", sans-serif',
  },
  quicksand: {
    fontFamily: '"Quicksand", "Arial", "Helvetica", sans-serif',
  },
});

export interface Props extends DistributiveOmit<TypographyProps, 'classes'>, WithStyles<typeof styles> {
  font?: 'montserrat' | 'quicksand';
  component?: React.ElementType;
}

function isHeadline(variant: Variant | 'inherit'): boolean {
  return variant === 'h1' || variant === 'h2' || variant === 'h3' || variant === 'h4' || variant === 'h5' || variant === 'h6';
}

function Typography(props: Props) {
  const { font, className: cn, classes, variant, ...others } = props;
  const className = classNames({
    ...(cn !== undefined && { [cn]: true }),
    [classes.montserrat]: font === 'montserrat' || (!font && (!variant || !isHeadline(variant))),
    [classes.quicksand]: font === 'quicksand' || (!font && variant && isHeadline(variant)),
  });
  return <MuiTypography className={className} variant={variant} {...others} />;
}

export default withStyles(styles)(Typography);
